'use client'

import { useRouter } from 'next/navigation'
import { Button, Grid, Link, Typography } from '@mui/material'
import { Form, Formik } from 'formik'
import * as yup from 'yup'

import FormikTextField from '@/components/global/forms/FormikTextField'

import { MESSAGES, ROLES, ROUTES, UTILS } from '@/shared/constants'
import useAuthApi from '@/hooks/useAuthApi'
import Loading from '@/components/global/layout/Loading'
import { PasswordField } from '../components/PasswordField'

const validationSchema = yup.object({
  email: yup
    .string()
    .email(MESSAGES.INVALID_FORMAT)
    .required(MESSAGES.REQUIRED_FIELD),
  password: yup.string().required(MESSAGES.REQUIRED_FIELD),
})

export default function Login() {
  const router = useRouter()
  const { login } = useAuthApi()

  const initialValues = {
    email: UTILS.BLANK,
    password: UTILS.BLANK,
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true)
        const user = await login(values.email, values.password)
        setSubmitting(false)
        if (user) {
          const roleId = user.role?.id ?? user.roleId
          const destination =
            roleId === ROLES.ADMIN || roleId === ROLES.COMPANY_ADMIN
              ? ROUTES.ROOT.PATH
              : ROUTES.CONVERSATIONS.PATH

          router.replace(destination)
          router.refresh()
        }
      }}
    >
      {({ submitForm, isSubmitting }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              submitForm()
            }
          }}
        >
          <Loading open={isSubmitting} />
          <Grid container rowSpacing={3}>
            <Grid size={12}>
              <FormikTextField
                fullWidth
                variant="outlined"
                name="email"
                type="email"
                label="E-mail"
              />
            </Grid>
            <Grid size={12}>
              <PasswordField name="password" label="Senha" />
            </Grid>
            <Grid size={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                onClick={submitForm}
              >
                Entrar
              </Button>
            </Grid>
            <Grid size={12}>
              <Typography variant="bodySm">
                Esqueceu sua senha?{UTILS.SPACE}
                <Link
                  href={ROUTES.REQUEST_RESET_PASSWORD.PATH}
                  underline="hover"
                >
                  Clique aqui
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
